import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { BatchVm } from './batch.vm';

export class GetProductBatchesVm extends PageResponseVm<BatchVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => BatchVm)
  objects: BatchVm[];
}
